import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AltNeuTextViewComponent } from './alt-neu-text-view.component';
import { TextInputComponent } from './text-input.component';

@Component({
    standalone: true,
    imports: [CommonModule, TextInputComponent],
    selector: 'wd-an-text-input',
    templateUrl: 'alt-neu-text-input.component.html',
    styleUrls: ['../styles/input.component.css', '../styles/view.component.css'],
})
export class AltNeuTextInputComponent extends AltNeuTextViewComponent {
	constructor() {
		super();
	}
}
